import {BaseContainerModel} from '../../base-container.model';
import {bl_cms_widget_hdr_RowClass} from '../../../dbschema';

export class WidgetHeaderContainerModel extends BaseContainerModel {
  bl_cms_widget_hdr: bl_cms_widget_hdr_RowClass = new bl_cms_widget_hdr_RowClass();
}
